import { render } from "./ModelAnalytics.vue?vue&type=template&id=6b47dd38"
import script from "./ModelAnalytics.vue?vue&type=script&lang=js"
export * from "./ModelAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__